var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"before-footer-contact"}},[_c('h2',[_vm._v("お問い合わせ")]),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("もっと見る")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }